import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DvDialogContent } from '@devinco/ui/dds';
import { ReleaseDialogData } from '@features/release-notes-dialog/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { ReleaseNotesLinkComponent } from '@shared/components/release-notes-link/release-notes-link.component';

@Component({
  selector: 'app-version-information-dialog',
  imports: [TranslateModule, ReleaseNotesLinkComponent],
  templateUrl: './version-information-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './version-information-dialog.component.scss',
})
export class VersionInformationDialogComponent extends DvDialogContent<
  Partial<ReleaseDialogData> | undefined,
  VersionInformationDialogComponent
> {}
